import CreateStatusDescriptionForm from './CreateStatusDescriptionForm';

export default CreateStatusDescriptionForm;
